.modalWrapper {
  padding: '1.5rem 0 1.5rem 2.5rem';
  flex-direction: column;
}

.modalBodyText {
  font-size: 16px;
}

.error {
  color: var(--danger);
  padding-bottom: 0.5rem;
}

.row {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}

.rowItem {
  display: flex;
  flex: 1;
}
